import { Action } from '@ngrx/store';
import { ConfigModel } from './config.model';

export const LOAD_REQUEST =  '[Config] Load Request';
export const LOAD_SUCCESS =  '[Config] Load Success';
export const LOAD_ERROR =    '[Config] Load Error';

export class LoadRequestAction implements Action {
    readonly type = LOAD_REQUEST;
}

export class LoadSuccessAction implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: ConfigModel) { }
}

export class LoadErrorAction implements Action {
    readonly type = LOAD_ERROR;

    constructor(public payload: any) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = LoadRequestAction
    | LoadSuccessAction
    | LoadErrorAction;

export type ResponseActions
    = LoadSuccessAction
    | LoadErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.actions.ts